import React from "react";
import { Phone, Star, ArrowRight } from "lucide-react";
import { CONTACT, STATS } from "@/data/content";
import { LOGO_URL } from "@/components/Logo";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative bg-[#0A0A0A] overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl pt-36 pb-0 md:pt-44">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          {/* Left: heavy type */}
          <div className="lg:col-span-7 pb-16 lg:pb-28">
            <div className="flex items-center gap-2 mb-6 animate-fade-up">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-[#D86C1E] text-[#D86C1E]" />
                ))}
              </div>
              <span className="text-sm uppercase tracking-[0.2em] font-bold text-white/70">
                4.9 Rated · Phoenix, AZ
              </span>
            </div>

            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter uppercase leading-[0.95] text-white animate-fade-up">
              Arizona's Roof,
              <br />
              <span className="text-[#D86C1E]">Done Right.</span>
              <br />
              <span className="text-stroke-white">Every Time.</span>
            </h1>

            <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/70 animate-fade-up">
              Honest, expert roofing from{" "}
              <span className="text-white font-semibold">Schuyler Corder</span> of{" "}
              <span className="text-white font-semibold">Blessed Roofing</span> — backed by
              Pro West. Repairs, replacements, storm damage, and 24/7 emergency service across
              the entire Valley and beyond.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-up">
              <a
                href="#quote"
                data-testid="hero-cta-button"
                className="group inline-flex items-center justify-center gap-2 bg-[#D86C1E] hover:bg-[#B0551A] text-white font-heading font-bold text-base uppercase tracking-wide px-8 py-4 transition-all hover:-translate-y-1 shadow-lg"
              >
                Get My Free Quote
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={`tel:${CONTACT.phoneRaw}`}
                data-testid="hero-call-button"
                className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-[#D86C1E] text-white font-heading font-bold text-base uppercase tracking-wide px-8 py-4 transition-all"
              >
                <Phone className="h-5 w-5 text-[#D86C1E]" />
                {CONTACT.phone}
              </a>
            </div>
          </div>

          {/* Right: brand emblem */}
          <div className="lg:col-span-5 relative flex items-center justify-center pb-16 lg:pb-28">
            <div className="relative">
              {/* sunset glow */}
              <div
                className="absolute inset-0 -m-10 rounded-full blur-3xl opacity-60"
                style={{
                  background:
                    "radial-gradient(circle, #D86C1E 0%, rgba(216,108,30,0.25) 45%, transparent 70%)",
                }}
              />
              <img
                src={LOGO_URL}
                alt="Blessed Roofing — Schuyler Corder, Pro West"
                className="relative w-72 sm:w-80 lg:w-[26rem] rounded-2xl shadow-2xl ring-1 ring-white/10 animate-fade-up"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Stats strip */}
      <div className="border-t border-white/10 bg-[#0A0A0A]">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`} className="py-8 px-4 text-center md:text-left">
              <div className="font-heading text-3xl md:text-4xl font-black text-white">
                {s.value}
              </div>
              <div className="text-xs uppercase tracking-wider text-white/50 mt-1">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
